import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    const titleElement = document.querySelector('meta[property="og:title"]');
    const urlElement = document.querySelector('meta[property="og:url"]');
    const descriptionElement = document.querySelector('meta[property="og:description"]');
    const imageElement = document.querySelector('meta[property="og:image"]');

    const title = titleElement?.getAttribute("content") || document.title;
    const url = urlElement?.getAttribute("content") || window.location.href;
    const description = descriptionElement ? descriptionElement.getAttribute("content") || "" : "";
    const image = imageElement ? imageElement.getAttribute("content") || "" : "";

    const shareLink = this.element;
    const href = shareLink.getAttribute("href")
      .replaceAll("{title}", encodeURIComponent(title))
      .replaceAll("{url}", encodeURIComponent(url))
      .replaceAll("{description}", encodeURIComponent(description))
      .replaceAll("{image}", encodeURIComponent(image));

    if (shareLink.getAttribute("href") !== "#") {
      shareLink.setAttribute("href", href);
    }
  }

  sharePage(event) {
    const url = event.currentTarget.getAttribute("href");
    if (url.startsWith("mailto:")) { return; }
    event.preventDefault();
    window.open(url, '_blank', 'width=600,height=400');
  }

  printPage(event) {
    event.preventDefault();
    window.print();
  }
}